import { IState } from '../reducers'

export const getTopicsModalIsOpen = (state: IState): boolean => state.topicsModal.isOpen
export const getTopicsModalIsLoading = (state: IState): boolean => state.topicsModal?.isLoading
export const getTopicsModalList = (state: IState): any[] => state?.topicsModal?.list
export const getTopicsModalUniqueSourcesCount = (state: IState): number => state.topicsModal.uniqueSourcesCount
export const getTopicsModalMainTopic = (state: IState): any => state?.topicsModal?.mainTopic
export const getTopicsModalReferencesIds = (state: IState): number[] => state.topicsModal.referencesIds
export const getTopicsModalPeriod = (state: IState): string => state.topicsModal.period
export const getTopicsModalFrom = (state: IState): string => state.topicsModal.from
export const getTopicsModalTo = (state: IState): string => state.topicsModal.to

